import { render, staticRenderFns } from "./StaticHouse.vue?vue&type=template&id=22050226&scoped=true"
import script from "./StaticHouse.vue?vue&type=script&lang=js"
export * from "./StaticHouse.vue?vue&type=script&lang=js"
import style0 from "./StaticHouse.vue?vue&type=style&index=0&id=22050226&prod&lang=css"
import style1 from "./StaticHouse.vue?vue&type=style&index=1&id=22050226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22050226",
  null
  
)

export default component.exports